const VolunteerInitialText ="This is your opportunity to help out individuals in " +
    "the community and earn some additional 'mood points'. " +
    "Several volunteer options are displayed below.  Choose the one that sounds best " +
    "to you."
        
export default VolunteerInitialText 
 